import { ReactComponent as Gift } from "assets/icons/coming-soon.svg";

export const NoData = () => {
  return (
    <div className="p-4">
      <div className=" flex flex-col justify-center items-center gap-4 py-6 px-12">
        <div className="space-y-2 flex flex-col">
          <span className="text-xl text-center">No Data Found!</span>
        </div>
      </div>
    </div>
  );
};
